var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-filter-form',{attrs:{"filter":_vm.filterForm,"fields":_vm.allFields,"default-common-fields":_vm.defaultCommonFields,"default-more-fields":_vm.defaultMoreFields,"config-key":"faultFilterConfig"},on:{"change":_vm.handleFieldChange,"search":_vm.handleSearch,"reset":_vm.handleReset},scopedSlots:_vm._u([{key:"field",fn:function({ field, form, reset, labelCol, wrapperCol }){return [_c('fault-filter-form-item',{attrs:{"form":form,"field":field,"options":{
        faultLevels: _vm.faultLevels,
        faultRecapStatus: _vm.faultRecapStatus,
        domainData: _vm.domainData,
        tagData: _vm.tagData,
        projects: _vm.projects
      },"reset":reset,"label-col":labelCol,"wrapper-col":wrapperCol},on:{"change":_vm.handleFieldChange}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }